import { GetterTree } from "vuex";
import { RootState } from "@/store/types";

import { AutomationState } from "../types";

const getters: GetterTree<AutomationState, RootState> = {
  getThreshold: (state) => state.threshold,
  getThresholdFacial: (state) => state.thresholdFacial,
  getRetentionDays: (state) => state.retentionDays,
  isEnabled: (state) => state.enabled,
  isEnabledReview: (state) => state.enabledReview,
};

export default getters;
